// extracted by mini-css-extract-plugin
export var DesktopPadding = "index-module--DesktopPadding--6a9da";
export var SVGWrapper = "index-module--SVGWrapper--9b9d6";